import React from "react";
import { Container } from "reactstrap";

interface ProposalFormLayoutProps {
  children: React.ReactNode;
  stepper: React.ReactNode;
  footer: React.ReactNode;
}

const ProposalFormLayout: React.FC<ProposalFormLayoutProps> = ({
  children,
  stepper,
  footer,
}) => {
  return (
    <div className="page-content">
      <Container fluid className="border pt-4 rounded-4 bg-light mb-3 ms-3 pe-4">
        {/* Header Section */}
        <div className="proposal-header">
          <h1>Life Insurance Proposal Form</h1>
          <p>Complete your application in 9 simple steps.</p>
          
          {/* Stepper */}
          {stepper}
        </div>

        {/* Main Content Section */}
        <div className="mb-4">
          {children}
        </div>

        {/* Footer Section */}
        <div>
          {footer}
        </div>
      </Container>
    </div>
  );
};

export default ProposalFormLayout;

